import { style } from '@vanilla-extract/css';

// No blur: the tour explains what is behind its modals.
export const tourOverlay = style({
  backdropFilter: 'none',
});
